import { Banner, Text } from '@spotify-internal/encore-web';
import { LoadingOverlay } from '@spotify/confidence-core-react';

import { Branding } from './Branding';
import { IntroStep } from './IntroStep';
import { useAccountLogin } from './hooks/useAccountLogin';
import type { InviteResponse } from './hooks/useInvite';
import final from './img/final.png';

export const AccountCreated = ({
  createdAccount,
}: {
  createdAccount: NonNullable<InviteResponse['createdAccount']>;
}) => {
  const { error, loading, login } = useAccountLogin(createdAccount.loginId);

  return (
    <>
      <Branding />
      <IntroStep
        title="Wonderful! You're all set!"
        img={final}
        description={
          <>
            {error && (
              <Banner colorSet="negative" contextual role="alert">
                {error.message.length === 0
                  ? 'Something went wrong'
                  : error.message}
              </Banner>
            )}
            <Text as="div" variant="bodyMedium">
              Psst. Your workspace ID is{' '}
              <Text
                as="span"
                variant="bodyMedium"
                semanticColor="textBrightAccent"
              >
                {createdAccount.loginId}
              </Text>
              .<br /> Don&apos;t lose it! You&apos;ll need it to log in.
            </Text>
          </>
        }
        buttonLabel="Log in"
        onNext={login}
        disabled={loading}
      />
      <LoadingOverlay loading={loading} />
    </>
  );
};
